import {ChangeDetectorRef, Directive, Input} from '@angular/core';
import {ControlValueAccessor} from '@angular/forms';

@Directive()
export abstract class AbstractValueAccessor<T> implements ControlValueAccessor {
    @Input() value: T = null;
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;

    constructor(protected cd: ChangeDetectorRef) {
    }

    private _isLoading: boolean = false;

    get isLoading(): boolean {
        return this._isLoading
    }

    @Input() set isLoading(loading: boolean) {
        if (!loading) {
            setTimeout(() => {
                this._isLoading = loading
                this.cd.markForCheck()
            })
        } else {
            this._isLoading = loading
        }
    }

    onChange = (value: any) => {
    };
    onTouched = () => {
    };

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cd.markForCheck();
    }

    writeValue(obj: any): void {
        this.value = obj;
        this.onChange(this.value);
        this.cd.markForCheck();
    }

    updateValue(value: T) {
        if (this.disabled) {
            return;
        }
        this.value = value;
        this.onChange(this.value);
        this.onTouched();
    }

}
